/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VolunteerRouteImport } from './routes/volunteer'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AppScanRouteImport } from './routes/app.scan'
import { Route as AppProfileRouteImport } from './routes/app.profile'
import { Route as AppMapRouteImport } from './routes/app.map'
import { Route as AppCertificateRouteImport } from './routes/app.certificate'
import { Route as AppBookingsRouteImport } from './routes/app.bookings'
import { Route as AppAnnouncementsRouteImport } from './routes/app.announcements'
import { Route as AppAiRouteImport } from './routes/app.ai'
import { Route as AdminWalksRouteImport } from './routes/admin.walks'
import { Route as AdminVolunteersRouteImport } from './routes/admin.volunteers'
import { Route as AdminTemplesRouteImport } from './routes/admin.temples'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminRickshawsRouteImport } from './routes/admin.rickshaws'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as AdminMembersRouteImport } from './routes/admin.members'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminJainYatraPdfRouteImport } from './routes/admin.jain-yatra-pdf'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminGuidesRouteImport } from './routes/admin.guides'
import { Route as AdminCityRouteImport } from './routes/admin.city'
import { Route as AdminCertificatesRouteImport } from './routes/admin.certificates'
import { Route as AdminBreakfastRouteImport } from './routes/admin.breakfast'
import { Route as AdminBookingsRouteImport } from './routes/admin.bookings'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin.announcements'
import { Route as AppTemplesIndexRouteImport } from './routes/app.temples.index'
import { Route as AppTemplesIdRouteImport } from './routes/app.temples.$id'

const VolunteerRoute = VolunteerRouteImport.update({
  id: '/volunteer',
  path: '/volunteer',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AppScanRoute = AppScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppMapRoute = AppMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppRoute,
} as any)
const AppCertificateRoute = AppCertificateRouteImport.update({
  id: '/certificate',
  path: '/certificate',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingsRoute = AppBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AppRoute,
} as any)
const AppAnnouncementsRoute = AppAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AppRoute,
} as any)
const AppAiRoute = AppAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppRoute,
} as any)
const AdminWalksRoute = AdminWalksRouteImport.update({
  id: '/walks',
  path: '/walks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVolunteersRoute = AdminVolunteersRouteImport.update({
  id: '/volunteers',
  path: '/volunteers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTemplesRoute = AdminTemplesRouteImport.update({
  id: '/temples',
  path: '/temples',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRickshawsRoute = AdminRickshawsRouteImport.update({
  id: '/rickshaws',
  path: '/rickshaws',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMembersRoute = AdminMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJainYatraPdfRoute = AdminJainYatraPdfRouteImport.update({
  id: '/jain-yatra-pdf',
  path: '/jain-yatra-pdf',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGuidesRoute = AdminGuidesRouteImport.update({
  id: '/guides',
  path: '/guides',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCityRoute = AdminCityRouteImport.update({
  id: '/city',
  path: '/city',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCertificatesRoute = AdminCertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBreakfastRoute = AdminBreakfastRouteImport.update({
  id: '/breakfast',
  path: '/breakfast',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBookingsRoute = AdminBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AdminRoute,
} as any)
const AppTemplesIndexRoute = AppTemplesIndexRouteImport.update({
  id: '/temples/',
  path: '/temples/',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplesIdRoute = AppTemplesIdRouteImport.update({
  id: '/temples/$id',
  path: '/temples/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/volunteer': typeof VolunteerRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/breakfast': typeof AdminBreakfastRoute
  '/admin/certificates': typeof AdminCertificatesRoute
  '/admin/city': typeof AdminCityRoute
  '/admin/guides': typeof AdminGuidesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/jain-yatra-pdf': typeof AdminJainYatraPdfRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/rickshaws': typeof AdminRickshawsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/temples': typeof AdminTemplesRoute
  '/admin/volunteers': typeof AdminVolunteersRoute
  '/admin/walks': typeof AdminWalksRoute
  '/app/ai': typeof AppAiRoute
  '/app/announcements': typeof AppAnnouncementsRoute
  '/app/bookings': typeof AppBookingsRoute
  '/app/certificate': typeof AppCertificateRoute
  '/app/map': typeof AppMapRoute
  '/app/profile': typeof AppProfileRoute
  '/app/scan': typeof AppScanRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/temples/$id': typeof AppTemplesIdRoute
  '/app/temples/': typeof AppTemplesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/volunteer': typeof VolunteerRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/breakfast': typeof AdminBreakfastRoute
  '/admin/certificates': typeof AdminCertificatesRoute
  '/admin/city': typeof AdminCityRoute
  '/admin/guides': typeof AdminGuidesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/jain-yatra-pdf': typeof AdminJainYatraPdfRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/rickshaws': typeof AdminRickshawsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/temples': typeof AdminTemplesRoute
  '/admin/volunteers': typeof AdminVolunteersRoute
  '/admin/walks': typeof AdminWalksRoute
  '/app/ai': typeof AppAiRoute
  '/app/announcements': typeof AppAnnouncementsRoute
  '/app/bookings': typeof AppBookingsRoute
  '/app/certificate': typeof AppCertificateRoute
  '/app/map': typeof AppMapRoute
  '/app/profile': typeof AppProfileRoute
  '/app/scan': typeof AppScanRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/app/temples/$id': typeof AppTemplesIdRoute
  '/app/temples': typeof AppTemplesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/volunteer': typeof VolunteerRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/breakfast': typeof AdminBreakfastRoute
  '/admin/certificates': typeof AdminCertificatesRoute
  '/admin/city': typeof AdminCityRoute
  '/admin/guides': typeof AdminGuidesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/jain-yatra-pdf': typeof AdminJainYatraPdfRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/rickshaws': typeof AdminRickshawsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/temples': typeof AdminTemplesRoute
  '/admin/volunteers': typeof AdminVolunteersRoute
  '/admin/walks': typeof AdminWalksRoute
  '/app/ai': typeof AppAiRoute
  '/app/announcements': typeof AppAnnouncementsRoute
  '/app/bookings': typeof AppBookingsRoute
  '/app/certificate': typeof AppCertificateRoute
  '/app/map': typeof AppMapRoute
  '/app/profile': typeof AppProfileRoute
  '/app/scan': typeof AppScanRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/temples/$id': typeof AppTemplesIdRoute
  '/app/temples/': typeof AppTemplesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/volunteer'
    | '/admin/announcements'
    | '/admin/bookings'
    | '/admin/breakfast'
    | '/admin/certificates'
    | '/admin/city'
    | '/admin/guides'
    | '/admin/login'
    | '/admin/members'
    | '/admin/users'
    | '/admin/jain-yatra-pdf'
    | '/admin/payments'
    | '/admin/rickshaws'
    | '/admin/settings'
    | '/admin/temples'
    | '/admin/volunteers'
    | '/admin/walks'
    | '/app/ai'
    | '/app/announcements'
    | '/app/bookings'
    | '/app/certificate'
    | '/app/map'
    | '/app/profile'
    | '/app/scan'
    | '/admin/'
    | '/app/'
    | '/app/temples/$id'
    | '/app/temples/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/volunteer'
    | '/admin/announcements'
    | '/admin/bookings'
    | '/admin/breakfast'
    | '/admin/certificates'
    | '/admin/city'
    | '/admin/guides'
    | '/admin/login'
    | '/admin/members'
    | '/admin/users'
    | '/admin/jain-yatra-pdf'
    | '/admin/payments'
    | '/admin/rickshaws'
    | '/admin/settings'
    | '/admin/temples'
    | '/admin/volunteers'
    | '/admin/walks'
    | '/app/ai'
    | '/app/announcements'
    | '/app/bookings'
    | '/app/certificate'
    | '/app/map'
    | '/app/profile'
    | '/app/scan'
    | '/admin'
    | '/app'
    | '/app/temples/$id'
    | '/app/temples'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/volunteer'
    | '/admin/announcements'
    | '/admin/bookings'
    | '/admin/breakfast'
    | '/admin/certificates'
    | '/admin/city'
    | '/admin/guides'
    | '/admin/login'
    | '/admin/members'
    | '/admin/users'
    | '/admin/jain-yatra-pdf'
    | '/admin/payments'
    | '/admin/rickshaws'
    | '/admin/settings'
    | '/admin/temples'
    | '/admin/volunteers'
    | '/admin/walks'
    | '/app/ai'
    | '/app/announcements'
    | '/app/bookings'
    | '/app/certificate'
    | '/app/map'
    | '/app/profile'
    | '/app/scan'
    | '/admin/'
    | '/app/'
    | '/app/temples/$id'
    | '/app/temples/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  VolunteerRoute: typeof VolunteerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/volunteer': {
      id: '/volunteer'
      path: '/volunteer'
      fullPath: '/volunteer'
      preLoaderRoute: typeof VolunteerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/scan': {
      id: '/app/scan'
      path: '/scan'
      fullPath: '/app/scan'
      preLoaderRoute: typeof AppScanRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/map': {
      id: '/app/map'
      path: '/map'
      fullPath: '/app/map'
      preLoaderRoute: typeof AppMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/certificate': {
      id: '/app/certificate'
      path: '/certificate'
      fullPath: '/app/certificate'
      preLoaderRoute: typeof AppCertificateRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/bookings': {
      id: '/app/bookings'
      path: '/bookings'
      fullPath: '/app/bookings'
      preLoaderRoute: typeof AppBookingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/announcements': {
      id: '/app/announcements'
      path: '/announcements'
      fullPath: '/app/announcements'
      preLoaderRoute: typeof AppAnnouncementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/ai': {
      id: '/app/ai'
      path: '/ai'
      fullPath: '/app/ai'
      preLoaderRoute: typeof AppAiRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/walks': {
      id: '/admin/walks'
      path: '/walks'
      fullPath: '/admin/walks'
      preLoaderRoute: typeof AdminWalksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/volunteers': {
      id: '/admin/volunteers'
      path: '/volunteers'
      fullPath: '/admin/volunteers'
      preLoaderRoute: typeof AdminVolunteersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/temples': {
      id: '/admin/temples'
      path: '/temples'
      fullPath: '/admin/temples'
      preLoaderRoute: typeof AdminTemplesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rickshaws': {
      id: '/admin/rickshaws'
      path: '/rickshaws'
      fullPath: '/admin/rickshaws'
      preLoaderRoute: typeof AdminRickshawsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payments': {
      id: '/admin/payments'
      path: '/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof AdminPaymentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/members': {
      id: '/admin/members'
      path: '/members'
      fullPath: '/admin/members'
      preLoaderRoute: typeof AdminMembersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jain-yatra-pdf': {
      id: '/admin/jain-yatra-pdf'
      path: '/jain-yatra-pdf'
      fullPath: '/admin/jain-yatra-pdf'
      preLoaderRoute: typeof AdminJainYatraPdfRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/guides': {
      id: '/admin/guides'
      path: '/guides'
      fullPath: '/admin/guides'
      preLoaderRoute: typeof AdminGuidesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/city': {
      id: '/admin/city'
      path: '/city'
      fullPath: '/admin/city'
      preLoaderRoute: typeof AdminCityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/certificates': {
      id: '/admin/certificates'
      path: '/certificates'
      fullPath: '/admin/certificates'
      preLoaderRoute: typeof AdminCertificatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/breakfast': {
      id: '/admin/breakfast'
      path: '/breakfast'
      fullPath: '/admin/breakfast'
      preLoaderRoute: typeof AdminBreakfastRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/bookings': {
      id: '/admin/bookings'
      path: '/bookings'
      fullPath: '/admin/bookings'
      preLoaderRoute: typeof AdminBookingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/announcements': {
      id: '/admin/announcements'
      path: '/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AdminAnnouncementsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/temples/': {
      id: '/app/temples/'
      path: '/temples'
      fullPath: '/app/temples/'
      preLoaderRoute: typeof AppTemplesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/temples/$id': {
      id: '/app/temples/$id'
      path: '/temples/$id'
      fullPath: '/app/temples/$id'
      preLoaderRoute: typeof AppTemplesIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAnnouncementsRoute: typeof AdminAnnouncementsRoute
  AdminBookingsRoute: typeof AdminBookingsRoute
  AdminBreakfastRoute: typeof AdminBreakfastRoute
  AdminCertificatesRoute: typeof AdminCertificatesRoute
  AdminCityRoute: typeof AdminCityRoute
  AdminGuidesRoute: typeof AdminGuidesRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminMembersRoute: typeof AdminMembersRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminJainYatraPdfRoute: typeof AdminJainYatraPdfRoute
  AdminPaymentsRoute: typeof AdminPaymentsRoute
  AdminRickshawsRoute: typeof AdminRickshawsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminTemplesRoute: typeof AdminTemplesRoute
  AdminVolunteersRoute: typeof AdminVolunteersRoute
  AdminWalksRoute: typeof AdminWalksRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnnouncementsRoute: AdminAnnouncementsRoute,
  AdminBookingsRoute: AdminBookingsRoute,
  AdminBreakfastRoute: AdminBreakfastRoute,
  AdminCertificatesRoute: AdminCertificatesRoute,
  AdminCityRoute: AdminCityRoute,
  AdminGuidesRoute: AdminGuidesRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminMembersRoute: AdminMembersRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminJainYatraPdfRoute: AdminJainYatraPdfRoute,
  AdminPaymentsRoute: AdminPaymentsRoute,
  AdminRickshawsRoute: AdminRickshawsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminTemplesRoute: AdminTemplesRoute,
  AdminVolunteersRoute: AdminVolunteersRoute,
  AdminWalksRoute: AdminWalksRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppRouteChildren {
  AppAiRoute: typeof AppAiRoute
  AppAnnouncementsRoute: typeof AppAnnouncementsRoute
  AppBookingsRoute: typeof AppBookingsRoute
  AppCertificateRoute: typeof AppCertificateRoute
  AppMapRoute: typeof AppMapRoute
  AppProfileRoute: typeof AppProfileRoute
  AppScanRoute: typeof AppScanRoute
  AppIndexRoute: typeof AppIndexRoute
  AppTemplesIdRoute: typeof AppTemplesIdRoute
  AppTemplesIndexRoute: typeof AppTemplesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAiRoute: AppAiRoute,
  AppAnnouncementsRoute: AppAnnouncementsRoute,
  AppBookingsRoute: AppBookingsRoute,
  AppCertificateRoute: AppCertificateRoute,
  AppMapRoute: AppMapRoute,
  AppProfileRoute: AppProfileRoute,
  AppScanRoute: AppScanRoute,
  AppIndexRoute: AppIndexRoute,
  AppTemplesIdRoute: AppTemplesIdRoute,
  AppTemplesIndexRoute: AppTemplesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  VolunteerRoute: VolunteerRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { createStart } from '@tanstack/react-start'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
  }
}
